import classNames from 'classnames';
import { Moment } from 'moment';
import React from 'react';

import { ClassNameMap, makeStyles } from '@mui/styles';

import { translate } from '@vestahealthcare/common/i18n';
import { MemberDashboardTOC, TOCStatus } from '@vestahealthcare/common/models';
import {
  DATE_FORMAT_SHORT,
  EMPTY,
} from '@vestahealthcare/common/utils/constants';

import { Chip, StatusIndicator, Table } from 'styleguide-v2';

type Props = {
  className?: string;
  data?: MemberDashboardTOC[];
};

const getDateWithDiffDays = (date?: Moment, days?: number) => (
  <>
    {date?.format(DATE_FORMAT_SHORT) || EMPTY}{' '}
    {date && days !== undefined && (
      <Chip color="action" size="small">
        <span>{days}</span>
      </Chip>
    )}
  </>
);

const RECENT_TOC_COLUMNS = (styles: ClassNameMap<'status'>) => [
  {
    headerName: 'Status',
    component: ({ status, statusUpdatedAt }: MemberDashboardTOC) => (
      <StatusIndicator
        className={styles.status}
        color={TOCStatus.getColor(status)}
        status={status.description}
        subtitle={statusUpdatedAt?.format(DATE_FORMAT_SHORT)}
      />
    ),
  },
  {
    headerName: translate('toc.table.admitDate'),
    component: ({ admitDate, daysInpatient }: MemberDashboardTOC) => (
      <p className="no-margin">
        {getDateWithDiffDays(admitDate, daysInpatient)}
      </p>
    ),
  },
  {
    headerName: translate('toc.table.dischargeDate'),
    component: ({
      dischargeDate,
      businessDaysSinceDischargeDate,
    }: MemberDashboardTOC) => (
      <p className="no-margin">
        {getDateWithDiffDays(dischargeDate, businessDaysSinceDischargeDate)}
      </p>
    ),
  },
];

const useStyles = makeStyles({
  table: {
    marginTop: 1,
  },
  status: {
    '& > :first-child': {
      margin: '4px 0 0',
    },
    '& > :last-child': {
      marginTop: '-3px',
    },
  },
});

export const RecentTocTable = (props: Props) => {
  const styles = useStyles();

  return (
    <Table
      className={classNames(styles.table, props.className)}
      config={{
        columns: RECENT_TOC_COLUMNS(styles),
        compact: true,
        data: props.data || [],
        paginationOptions: [-1],
      }}
      empty={translate('memberProfile.dashboard.noRecentToc')}
      fontSize="small"
      whiteBackground
    />
  );
};
